import React, { Fragment } from 'react'
import { Redirect } from 'react-router'
import { If } from 'src/Components'
import Header from 'src/features/homeowners/Components/Header'
import NewHomeWizard from 'src/features/homeowners/Components/NewHomeWizard'
import HomeownerReportTeaser from 'src/Components/Teasers/HomeownerReportTeaser'
import HomeownerReportVideoSection from 'src/features/homeowners/Components/HomeownerReportVideoSection'

const NewHome = ({ hasHomes, notFound }) => (
  <Fragment>
    <If condition={notFound}>
      <Redirect to='/not-found' />
    </If>
    <Header />
    <NewHomeWizard />
    <If condition={!hasHomes}>
      <HomeownerReportTeaser />
      <HomeownerReportVideoSection />
    </If>
  </Fragment>
)

export default NewHome
